import { Modal, Row, Checkbox } from 'antd';
import React, { Component } from 'react';
import PartnerApi from '../../functions/api/partner/PartnerApi';
import MyUtil from '../../functions/MyUtil';

import { Col, Form, Input, Button } from 'antd';

export default class ModalProcedure extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modal: false,
      produces: [],
      procs: '',
    };
  }

  async componentDidMount() {
    var produces = await PartnerApi.getProcedures();
    var procs = this.props.procs ? this.props.procs : '';
    var procs_detail = this.props.procs_detail ? this.props.procs_detail : '';
    produces = produces ? produces : [];
    var arr = [];
    produces.forEach((element, index) => {
      var check = procs.indexOf(element.proc_name) !== -1;

      element = Object.assign(element, {
        checked: check,
        [element['proc_name'] + '_note']: '',
      });
      arr.push(element);
    });

    if (procs !== '' && procs != null) {
      arr = MyUtil.convertManyOption(procs);
    }
    var propNames = Object.getOwnPropertyNames(arr);

    var arrProduces = [];
    produces.forEach((element, index) => {
      var check = procs.indexOf(element.proc_name) !== -1;
      var check_only = false;
      if (check) {
        for (var i in procs_detail) {
          if (procs_detail[i]['proc']['proc_id'] == element['proc_id']) {
            check_only = procs_detail[i]['check_only'];
          }
        }
      }

      var note = arr[element['proc_name']];
      for (var i = 0; i < propNames.length; i++) {
        var propName = propNames[i];
        if (MyUtil.slug(propName) === MyUtil.slug(element.proc_name)) {
          note = arr[propName];
          check = true;
        }
      }

      if (procs)
        element = Object.assign(element, {
          checked: check,
          check_only: check_only,
          [element['proc_name'] + '_note']: note,
        });
      arrProduces.push(element);
    });

    this.setState({ produces: arrProduces });
  }

  handleChange = (event) => {
    var note = event.target.value;
    var produces = this.state.produces;
    if (produces) {
      produces.forEach((item, index) => {
        if (item.proc_name + '_note' === event.target.name) {
          produces[index][event.target.name] = note;
        }
      });
    }
    this.setState({ produces });
  };

  handleSelectOption = (event) => {
    var produces = this.state.produces;
    if (produces) {
      produces.forEach((item, index) => {
        if (item.proc_name === event.target.name) {
          if (event.target.checked) {
            produces[index].check_only = false;
            produces[index].checked = true;
          } else {
            if (!produces[index].check_only) {
              produces[index].checked = false;
            }
          }
          return;
        }
      });
      this.setState({ produces });
    }
  };

  handleSelectOptionReadonly = (event) => {
    var produces = this.state.produces;
    if (produces) {
      produces.forEach((item, index) => {
        if (item.proc_name === event.target.name) {
          if (event.target.checked) {
            produces[index].check_only = true;
            if (!produces[index].checked) {
              produces[index].checked = true;
            }
          } else {
            produces[index].check_only = false;
            produces[index].checked = false;
          }

          return;
        }
      });
      this.setState({ produces });
    }
  };

  handleSave = () => {
    var produces = this.state.produces;
    var procs = [];
    produces.forEach((item) => {
      if (item.checked) {
        procs.push(item);
      }
    });
    this.props.onChangeManyOption('procs', procs);
    // this.props.handleCloseModal('modalProduce');
    this.setState({
      modal: false,
    });
  };

  handleCancel = () => {
    this.setState({
      modal: false,
    });
    // this.props.handleCloseModal('modalProduce');
  };

  render() {
    const { produces, modal } = this.state;
    return (
      <>
        <Form.Item name={['procs']} label="Thủ tục">
          <Input type="hidden" />
        </Form.Item>
        <Button
          onClick={() => {
            this.setState({ modal: true });
          }}
        >
          Thêm/Thay đổi
        </Button>

        <Modal
          visible={modal}
          title="Thêm thủ tục của đối tác"
          onOk={this.handleSave}
          onCancel={this.handleCancel}
          width={800}
        >
          <Row className="row-form">
            <Col span={4} />
            <Col span={4} align="center">
              <b>Thế chấp</b>
              <br />
              (giữ lại)
            </Col>
            <Col span={4} align="center">
              <div>
                <b>Xác minh</b>
                <br />
                (không giữ lại)
              </div>
            </Col>
            <Col span={12}>
              <div>
                <b>Ghi chú</b>
              </div>
            </Col>
          </Row>
          {Object.keys(produces).map((key) => {
            return (
              <Row className="row-form" key={key}>
                <Col span={4}>
                  <div
                    className="lable-option"
                    style={{ width: '100px', display: '-webkit-inline-box' }}
                  >
                    {produces[key].proc_name}
                  </div>
                </Col>
                <Col span={4} align="center">
                  <Checkbox
                    name={produces[key].proc_name}
                    id={produces[key].proc_id}
                    type="checkbox"
                    checked={
                      produces[key]['checked']
                        ? produces[key]['check_only']
                          ? false
                          : true
                        : false
                    }
                    onChange={this.handleSelectOption}
                  />
                </Col>
                <Col span={4} align="center">
                  <Checkbox
                    name={produces[key].proc_name}
                    type="checkbox"
                    checked={produces[key]['check_only']}
                    onChange={this.handleSelectOptionReadonly}
                  />
                </Col>
                <Col span={12} style={{ padding: '3px' }}>
                  <div>
                    <Input
                      disabled={!produces[key]['checked']}
                      name={produces[key].proc_name + '_note'}
                      onChange={this.handleChange}
                      value={produces[key][produces[key].proc_name + '_note']}
                    ></Input>
                  </div>
                </Col>
              </Row>
            );
          })}
        </Modal>
      </>
    );
  }
}
